module.exports = __webpack_public_path__ + "img/task_stage.2859f3c7.png";